const PriceList = () => {
  return <div className="price-list"></div>;
};

export default PriceList;
